// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] || chunkId) + "." + {"43":"6204977b","234":"ffec5c47","239":"49784126","455":"38c0a55b","653":"5b65440d","844":"c920d124","977":"6a7a7e90"}[chunkId] + ".chunk.js";
};